

export default function(state = {}, action){

    // ações globais
    switch(action.type){

        // aplica os dados de login
        case 'permissaoReducer/ATUALIZAR':
            return {...state, ...action.dados};
        default: 
            return state
    }
}